import { Redirect } from 'react-router-dom';

export const NotFound = () => {
  return <Redirect to='/' />;
};
